// extracted by mini-css-extract-plugin
export default {"burgerConstructor":"style_burgerConstructor__lWxcl","order":"style_order__wQi1Z"};